import React, { Component } from 'react';
import { __, validateForm } from '../core/utils';
import { setNotification } from '../redux/actions/general/notification';
import {
  createCompanyTag,
  listCompanyTags,
  updateCompanyTag,
} from '../redux/actions/table/company_tags';
import CompanyTagForm from '../forms/company_tags/CompanyTagForm';

class CompanyTagWizard extends Component {
  handleSubmit = (data) => {
    const { tag } = this.props;
    const action = tag.id
      ? updateCompanyTag(tag.id, data)
      : createCompanyTag(data);

    return validateForm(
      action.then(() => {
        listCompanyTags();
        setNotification(
          tag.id
            ? __('company-tags.notification.updated', {}, 'Tag updated.')
            : __('company-tags.notification.created', {}, 'Tag created.'),
        );
        this.props.onClose();
      }),
    );
  };

  render() {
    const { tag, onClose } = this.props;

    return (
      <CompanyTagForm
        editing={Boolean(tag.id)}
        initialValues={{ name: tag.name || '' }}
        onClose={onClose}
        onSubmit={this.handleSubmit}
      />
    );
  }
}

export default CompanyTagWizard;
